import { useEffect, useRef } from "react";

import { useBooleanState } from ".";

export function useAsyncCall() {
  const mounted = useRef(false);
  const [running, setRunning, stopRunning] = useBooleanState();

  useEffect(() => {
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const makeCall = async (action) => {
    if (mounted.current) {
      setRunning();
      try {
        const r = await action();
        if (mounted.current) stopRunning();
        return r;
      } catch (e) {
        if (mounted.current) stopRunning();
        throw e;
      }
    }
    return null;
  };

  return [makeCall, running];
}

export default useAsyncCall;
